import type { MedalKind, MedalLandscape } from "@healthos/client-data";

// Vite emits the same masters used by Expo with content-hashed URLs. No second
// illustration library or runtime request to the mobile app is needed.
const models = import.meta.glob<string>("../../../../healthos-mobile/assets/medals/*.glb", {
  eager: true,
  query: "?url",
  import: "default",
});
const images = import.meta.glob<string>("../../../../healthos-mobile/assets/medals/*.jpg", {
  eager: true,
  query: "?url",
  import: "default",
});
const root = "../../../../healthos-mobile/assets/medals/";
export function medalSource(
  kind: MedalKind,
  landscape?: MedalLandscape,
  ordinal = 0,
  subdued = false,
): string {
  const name =
    kind === "streak" ? `streak-${Math.max(1, Math.min(4, ordinal))}` : (landscape ?? kind);
  const source = models[`${root}${name}${subdued ? "-locked" : ""}.glb`];
  if (!source) throw new Error(`Missing medal master: ${name}`);
  return source;
}
export function landscapeImage(landscape: MedalLandscape, subdued: boolean): string {
  return images[`${root}${landscape}${subdued ? "-locked" : ""}.jpg`] ?? "";
}
